import React, { FC } from 'react';
import Box from '@mui/material/Box';
import { ActivityMap } from './ActivityMap';
import { ActivityFetcher } from '../../fetchers/ActivityFetcher';
import { ActivityTable } from './ActivityTable';
import { PageHeader } from '../PageHeader/PageHeader';
import { useTranslation } from 'react-i18next';

export const AnalyticsActivity: FC = () => {
  const type = 'activeNow'; //useQueryParam('type') as AnalyticsActivityType | null;
  // const history = useHistory();
  const { t } = useTranslation();

  // const nowUrl = useQueryUrl('type', 'activeNow');
  // const todayUrl = useQueryUrl('type', 'activeToday');
  // const weekUrl = useQueryUrl('type', 'activeWeek');
  // const monthUrl = useQueryUrl('type', 'activeMonth');

  // useEffect(() => {
  //   if (!type) {
  //     const search = new URLSearchParams(history.location.search);
  //     search.set('type', 'activeNow');
  //     history.replace(`?${search}`);
  //   }
  // }, [type]);

  return (
    <div>
      <PageHeader title={t('analytics.header')} />

      {/*<ButtonGroup>*/}
      {/*<Button color={type === 'activeNow' ? 'secondary' : void 0} component={Link} to={nowUrl}>*/}
      {/*  Active now*/}
      {/*</Button>*/}
      {/*<Button color={type === 'activeToday' ? 'secondary' : void 0} component={Link} to={todayUrl}>*/}
      {/*  Active today*/}
      {/*</Button>*/}
      {/*<Button color={type === 'activeWeek' ? 'secondary' : void 0} component={Link} to={weekUrl}>*/}
      {/*  Week*/}
      {/*</Button>*/}
      {/*<Button color={type === 'activeMonth' ? 'secondary' : void 0} component={Link} to={monthUrl}>*/}
      {/*  Month*/}
      {/*</Button>*/}
      {/*</ButtonGroup>*/}
      {/*<Box>*/}
      {/*  <FormControl>*/}
      {/*    <FormControlLabel*/}
      {/*      control={<Checkbox checked={tfgFilter} onChange={toggleTfgFilter} />}*/}
      {/*      label={t('analytics.pixotopeFilter') as string}*/}
      {/*    />*/}
      {/*  </FormControl>*/}
      {/*</Box>*/}

      {type ? (
        <ActivityFetcher.WAF type={type}>
          <ActivityMap />

          <Box marginTop={1}>
            <ActivityTable />
          </Box>
        </ActivityFetcher.WAF>
      ) : null}
    </div>
  );
};
